import classNames from "classnames";
import {EmblaViewportRefType} from "embla-carousel-react";
import {ProductMediaSources} from "@/entities/product";
import {Picture} from "@/shared/ui/Picture";
import {Svg} from "@/shared/ui/Svg";
import {Video} from "@/shared/ui/Video";
import styles from "./ThumbsCarousel.module.scss";

type Props = {
    carouselRef: EmblaViewportRefType;
    media: ProductMediaSources[];
    alt: string;
    selectedIndex: number;
    onSelect: (index: number) => void;
    className?: string;
    onPrevButtonClick?: () => void;
    onNextButtonClick?: () => void;
    prevBtnDisabled?: boolean;
    nextBtnDisabled?: boolean;
}

export const ThumbsCarousel = (
    {
        media,
        carouselRef,
        onSelect,
        alt,
        selectedIndex,
        className,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled,
    }: Props
) => {
    return (
        <div className={className}>
            {!prevBtnDisabled && (
                <button type={`button`} className={classNames(styles.button, styles.buttonUp)}
                        onClick={onPrevButtonClick}>
                    <Svg id={`arrowUp`} className={styles.arrowIcon} />
                </button>
            )}
            {!nextBtnDisabled && (
                <button type={`button`} className={classNames(styles.button, styles.buttonDown)}
                        onClick={onNextButtonClick}>
                    <Svg id={`arrowDown`} className={styles.arrowIcon} />
                </button>
            )}
            <div ref={carouselRef} className={styles.viewport}>
                <div className={styles.container}>
                    {media.map((item, index) => {
                        const activeSlide = index === selectedIndex;
                        return (
                            <div
                                key={item.src}
                                className={classNames(styles.slide, {[styles.active]: activeSlide})}
                                onClick={() => onSelect(index)}
                            >
                                <div className={classNames(styles.inner, {[styles.active]: activeSlide})}>
                                    {item.type === 'video' && (
                                        <Video
                                            sources={[item.src]}
                                            preload={`metadata`}
                                            uiControls={false}
                                            autoPlay
                                            loop
                                        />
                                    )}
                                    {item.type === 'image' && (<Picture src={item.src} alt={alt} />)}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
